"use strict";

var _classCallCheck = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var idlUtils = require("../generated/utils");

exports.implementation =
/*#__PURE__*/
function () {
  function MimeTypeArray() {
    _classCallCheck(this, MimeTypeArray);
  }

  _createClass(MimeTypeArray, [{
    key: "item",
    value: function item() {
      return null;
    }
  }, {
    key: "namedItem",
    value: function namedItem() {
      return null;
    }
  }, {
    key: "length",
    get: function get() {
      return 0;
    }
  }, {
    key: idlUtils.supportedPropertyIndices,
    get: function get() {
      return [];
    }
  }, {
    key: idlUtils.supportedPropertyNames,
    get: function get() {
      return [];
    }
  }]);

  return MimeTypeArray;
}();